import securityCatalog, { expandPermissionCode, isSensitivePermissionCode, normalizePermissionCode } from './catalog.js';

export function getPermissionCodes(user) {
  const permissions = user?.permisos
    || user?.permissions
    || user?.permisosEfectivos
    || [];

  const codes = new Set();
  permissions
    .map((permission) => {
      if (typeof permission === 'string') return permission;
      return permission?.codigo || permission?.clave || permission?.code || null;
    })
    .filter(Boolean)
    .forEach((code) => {
      expandPermissionCode(code).forEach((candidate) => codes.add(candidate));
    });
  return codes;
}

export function can(user, permissionCode) {
  if (!permissionCode) return true;
  const role = String(user?.rol || '').toLowerCase();
  if (!isSensitivePermissionCode(permissionCode) && (role === 'admin' || role === 'developer' || role === 'dev')) return true;
  const codes = getPermissionCodes(user);
  return codes.has(permissionCode) || codes.has(normalizePermissionCode(permissionCode));
}

export function canAny(user, permissionCodes = []) {
  if (!permissionCodes?.length) return true;
  return permissionCodes.some((code) => can(user, code));
}

export function hasRole(user, roleCode) {
  const roles = user?.roles || [];
  return roles.some((role) => {
    const candidate = String(role?.codigo || role?.nombre || role).toLowerCase();
    return candidate === String(roleCode).toLowerCase();
  });
}

export function hasLevelAtLeast(user, level) {
  const userLevel = Number(user?.nivel || 0);
  return userLevel >= Number(level || 0);
}

export function getPermissionCodeForPath(path) {
  const codes = getPermissionCodesForPath(path);
  return codes[0] || null;
}

export function getPermissionCodesForPath(path) {
  if (!path) return [];
  const cleanPath = String(path).replace(/\/+$/, '') || '/';
  const codes = new Set();
  const direct = securityCatalog.routePermissions?.[cleanPath];
  if (direct) codes.add(direct);

  const directDefinitions = (securityCatalog.permissions || [])
    .filter((permission) => permission?.path === cleanPath)
    .map((permission) => permission.code);
  directDefinitions.forEach((code) => codes.add(code));

  const entries = Object.entries(securityCatalog.routePermissions || {});
  const matches = entries.filter(([pattern]) => {
    const regex = new RegExp(`^${pattern.replace(/:[^/]+/g, '[^/]+')}$`);
    return regex.test(cleanPath);
  });
  matches.forEach(([, code]) => codes.add(code));

  const definitionMatches = (securityCatalog.permissions || [])
    .filter((permission) => {
      const pattern = permission?.path;
      if (!pattern) return false;
      const regex = new RegExp(`^${pattern.replace(/:[^/]+/g, '[^/]+')}$`);
      return regex.test(cleanPath);
    })
    .map((permission) => permission.code);
  definitionMatches.forEach((code) => codes.add(code));

  return Array.from(codes);
}

export default {
  can,
  canAny,
  getPermissionCodeForPath,
  getPermissionCodesForPath,
  getPermissionCodes,
  hasLevelAtLeast,
  hasRole,
};
